import { gzip, ungzip } from 'pako';

export function compressToBase64(obj) {
    const json = JSON.stringify(obj);
    const compressed = gzip(json);
    return btoa(String.fromCharCode(...compressed));
}

export function decompressFromBase64(base64String) {
    const binaryString = atob(base64String);
    const charData = Uint8Array.from(binaryString, c => c.charCodeAt(0));
    const decompressed = ungzip(charData, { to: 'string' });
    return JSON.parse(decompressed);
}